export const getPlanColor = (metadata?: Record<string, any>) => {
  const color = (metadata?.color || metadata?.accent_color || '#1f2937').toLowerCase()
  const colors: Record<string, string> = {
    green: '#22c55e',
    emerald: '#10b981',
    blue: '#3b82f6',
    purple: '#8b5cf6',
    orange: '#f97316',
    amber: '#f59e0b',
    slate: '#334155',
    stone: '#292524',
  }

  return colors[color] || color
}

export const withAlpha = (hex: string, alpha: string) => {
  const value = hex.replace('#', '')
  if (!/^[0-9a-fA-F]{6}$/.test(value)) return undefined

  return `#${value}${alpha}`
}
